var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWeatherIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.857 29.5222C29.3758 26.6175 31.8841 24.3121 34.9344 23.0533C33.7263 18.4596 29.5446 15.0716 24.5717 15.0716C18.6543 15.0716 13.8573 19.8686 13.8573 25.786C13.8573 28.1859 14.6463 30.4015 15.9791 32.1875C18.1337 30.2129 21.0548 29.0001 24.2714 29.0001C25.5204 29.0001 26.7247 29.1829 27.857 29.5222Z",
    fill: "#FFC700"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0279 35.5079L30.5683 36.3078L31.1365 34.6677C32.8979 29.5841 37.7512 25.9288 43.4647 25.9288C50.6712 25.9288 56.5006 31.7402 56.5006 38.8933C56.5006 39.0403 56.4981 39.1867 56.4933 39.3324L56.4621 40.2653L57.2853 40.7053C59.1626 41.7089 60.4292 43.6754 60.4292 45.93C60.4292 49.1968 57.7659 51.8577 54.4649 51.8577H43.4651H43.4647L43.3798 51.8577L43.3328 51.8577H43.3178H43.3136H43.3125H43.3122H43.3122H43.3122H25.0003C20.1805 51.8577 16.2859 47.9716 16.2859 43.1935C16.2859 38.4154 20.1805 34.5293 25.0003 34.5293C26.4566 34.5293 27.8251 34.8833 29.0279 35.5079Z",
    stroke: "white",
    strokeWidth: 3
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeatherIcon);
export default __webpack_public_path__ + "static/media/WeatherIcon.16c47ef78fc7e3d4ec3165815e9a5eef.svg";
export { ForwardRef as ReactComponent };